"use strict";

var getAssetContent = require("./getAssetContent");

/**
 * @function
 * @description Init the Content Popin
 */
const initContentPopin = () => {
    const $popinButton = $(".js-popin-btn");

    $popinButton.on("click", e => {
        e.preventDefault();

        const $this = $(e.currentTarget);
        getAssetContent($this);
    });
};

module.exports = initContentPopin;
